<mat-expansion-panel [expanded]="expand">
  <mat-expansion-panel-header>
    <mat-panel-title>
      @if (!!data.entity.type) {
        @if (findEntityMeta(data.entity.type)?.iconUrl; as iconUrl) {
          <app-salesforce-entity-icon
            [iconUrl]="iconUrl"
            [iconColor]="findEntityMeta(data.entity.type)?.iconColor"
            [iconClass]="getIcon(data.entity.type)"
            imgClass="attach-file-entity-icon"
            [tooltip]="getEntityDisplayName(data.entity.type)">
          </app-salesforce-entity-icon>
        } @else {
          <i class="{{ getIcon(data.entity.type) }}" [matTooltip]="getEntityDisplayName(data.entity.type)" matTooltipShowDelay="500"></i>
        }
      } @else {
        <mat-icon fontSet="material-icons-outlined">description</mat-icon>
      }
      <span #ExpandDropdown class="middle"> {{ entityLabel }} from {{ data.entity.name }} </span>
      <div class="icon-container">
        @if (data.entity?.name) {
          <mat-icon
            #RefreshIcon
            fontIcon="autorenew"
            class="sync-icon right"
            (click)="refreshFiles($event)"
            [matTooltip]="'Resync files with ' + data.entity.name"
            matTooltipShowDelay="500"
            role="button"
          ></mat-icon>
        }
      </div>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-template matExpansionPanelContent>
    <main>
      @if (!showSpinner && files.length === 0) {
        <div class="box-no-files-text placeholder-text">NO FILES AVAILABLE FOR THIS ENTITY</div>
      }
      @if (renderMode === 'web-app') {
        <app-kp-simple-table
          [items]="files"
          [columnHeadings]="columnHeadings"
          [isLoading]="showSpinner"
          [selectableRows]="true"
          [skeletonRowClasses]="'big-row'"
          [skeletonRowInstances]="2"
          [tableClasses]="'hover-rows large-side-padding scrollable-container'"
          (rowClick)="tableRowClick($event)"
          (actionClick)="tableRowActionClick($event)"
        >
        </app-kp-simple-table>
      } @else {
        <lib-compact-file-list-view
          [files]="compactFileListViewFiles"
          (fileSelected)="tableRowClick($event)"
          (actionClick)="fileItemActionClick($event)"
        >
        </lib-compact-file-list-view>
      }
    </main>
  </ng-template>
</mat-expansion-panel>
